"use client";

import type { AdminLocale } from "./locale";
import { adminLocaleCookie, resolveAdminLocale } from "./locale";

const localeCookieMaxAge = 60 * 60 * 24 * 365;

export function setAdminLocaleCookie(locale: AdminLocale): void {
  document.cookie = `${adminLocaleCookie}=${locale}; path=/; max-age=${localeCookieMaxAge}; samesite=lax`;
  document.documentElement.lang = locale;
  document.documentElement.dir = locale === "ar" ? "rtl" : "ltr";
}

export function preferredLocaleFromUser(user: { preferredLocale?: string | null } | null | undefined): AdminLocale {
  return resolveAdminLocale(user?.preferredLocale);
}
